module.exports = __webpack_public_path__ + "img/rx-station-white.b1ac4da3.png";